import { use } from "react";
import { EntityUploadSessionsContext } from "lib/contexts/GlobalContexts/EntityUploadSessionsContext";

export const useEntityUploadSessions = () => {
  return use(EntityUploadSessionsContext);
};
